import React from 'react';
import beer from '../../../../api/beer.js';
import './beerItem.css';
import LoadingAnimation from '../../../loading-animation/loading-animation'

class BeerItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      beer:props.beer,
      loading:true,
      beer_api:{},
    };
  }

  componentWillReceiveProps(props){
    this.setState({beer:props.beer},()=>{
      if(this.state.beer.id !== this.state.beer_api.id){
        this.getBeerFromApi()

      }
    })

  }
  getBeerFromApi(){
    beer.getSingleBeer(this.state.beer.id)
    .then((app)=> {
      this.setState({
        loading:false,
        beer_api: app.data.data
      })
    })
    .catch((error)=>{
      console.log(error)
      this.setState({
        loading:false,
        errorMessage:error.message
      })
    });
  }
  handleChange(event){
    event.preventDefault()
    let beer = this.state.beer;
    beer.price = event.target.value;
    this.setState({
      beer
    })
    this.props.onBeerUpdate(beer);
  }

  componentDidMount(){
    this.getBeerFromApi();
  };

  render() {

    let listPrices;
    if(this.state.beer && this.state.beer.prices){
      let prices = this.state.beer.prices;
      listPrices = prices.map((price,index) =>
        <h2 className="t1-beeritem-priceitem" key={index}>
          {price}
        </h2>
      );
    }

    let beerName;
    if(this.state.beer_api && this.state.beer_api.brewery_name && this.state.beer_api.beer_name){
      beerName =
        <h1 className="t1-beeritem-text-name">
          {this.state.beer_api.beer_name}
        </h1>
    }

    let beerDescription;
    if(this.state.beer_api && this.state.beer_api.beer_style_name){
      beerDescription =
        <p className="t1-beeritem-text-description">
          {this.state.beer_api.brewery_name} &bull; {this.state.beer_api.beer_style_name} &bull; {Number(this.state.beer_api.beer_abv).toFixed(1)}%ABV
        </p>
    }

    let loadingBeer;
    if(!this.state.beer_api.beer_style_name){
      loadingBeer = <LoadingAnimation/>
    }

    return (
      <div className="t1-beeritem-container">
        <div className="t1-beeritem-number-container">
          <h1 className="t1-beeritem-number">
            {this.props.index + 1}
          </h1>
        </div>
        <div className="t1-beeritem-text-container">
          {loadingBeer}
          {beerName}
          {beerDescription}
        </div>
        <div className="t1-beeritem-price-container">
          {listPrices}
        </div>
      </div>
    );
  }
}

export default BeerItem;



// WEBPACK FOOTER //
// ./src/components/application/templates/t1-beerlist/beeritem.js